export const statusList = [
  { id: "active", name: "Active" },
  { id: "inactive", name: "Inactive" },
];
